import { StyleSheet } from 'aphrodite'

export default StyleSheet.create({
  crumb: {
    display: 'inline-block',
    background: '#e2e2e2',
    cursor: 'pointer',
    userSelect: 'none',
    padding: '0 5px',
    textAlign: 'center',
    lineHeight: '20px',
    zIndex: 1,
    marginLeft: 10,
    marginRight: 2, // This controls the gap between crumbs
    left: -1,
    position: 'relative',
    ':hover': {
      background: '#cacaca'
    },
    '::before': {
      content: '" "',
      display: 'block',
      width: 0,
      height: 0,
      borderTop: '10px solid #e2e2e2',
      borderBottom: '10px solid #e2e2e2',
      borderLeft: '8px solid transparent',
      position: 'absolute',
      top: '50%',
      marginTop: -10,
      left: -8,
      zIndex: 1
    },
    ':hover:before': {
      borderBottomColor: '#cacaca',
      borderTopColor: '#cacaca'
    },
    '::after': {
      display: 'block',
      content: '" "',
      position: 'absolute',
      left: '100%',
      top: '50%',
      height: 0,
      width: 0,
      zIndex: 2,
      marginTop: -10,
      borderLeft: '8px solid #e2e2e2',
      borderBottom: '10px solid transparent',
      borderTop: '10px solid transparent'
    },
    ':hover:after': {
      borderLeftColor: '#cacaca'
    }
  },
  crumbContent: {
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  breadcrumbs: {
    display: 'block'
  }
})



// WEBPACK FOOTER //
// ./src/components/Media/Breadcrumbs/styles.js